import { graphql } from 'react-relay';
import { usePromiseMutation } from '@sparknz/journeys-common';
import { useSnackbar } from '@sparknz/spark-pattern-library';

import { useUpdateCartAccountMutation } from '__generated__/useUpdateCartAccountMutation.graphql';
import { useCartCheckoutActions } from 'journey/cart/providers';
import { useCartCookie, useSegment } from 'shared/hooks';
import { useCartAction } from '../useCartAction';

const updateCartAccountMutation = graphql`
  mutation useUpdateCartAccountMutation($input: AddAccountToCartInput!) {
    addAccountToCart(input: $input) {
      message
      code
      success
    }
  }
`;

export default function useUpdateCartAccount(
  defaultCartQueryFetchKey?: string,
) {
  const { cartId } = useCartCookie();
  const { channel } = useSegment();
  const { showSnackbar } = useSnackbar();
  const mutateUpdateCartAccount =
    usePromiseMutation<useUpdateCartAccountMutation>(updateCartAccountMutation);
  const { refreshCartItems } = useCartAction(defaultCartQueryFetchKey);
  const { setExistingCustomerCheckoutButtonState } = useCartCheckoutActions();

  function handleSuccess() {
    refreshCartItems();
    setExistingCustomerCheckoutButtonState('initial');
  }

  function handleError() {
    showSnackbar({
      text: 'Something went wrong',
    });
  }

  async function updateCartAccount(accountNumber: string) {
    try {
      await mutateUpdateCartAccount({
        input: { accountNumber, cartId, channel },
      });
      handleSuccess();
    } catch {
      handleError();
    }
  }

  return { updateCartAccount };
}
